import React from 'react';
import { usePageTitle } from '../hooks/usePageTitle';
import PageHeader from '../components/PageHeader';
import { useSettings } from '../context/SettingsContext';

const PrivacyPolicy = () => {
  usePageTitle('Chính sách bảo mật');
  const { settings } = useSettings();
  const shopName = settings.shop_name || 'Hoa Tháng Năm';
  const phone = settings.phone || '039 262 1101';
  const email = settings.email || 'hoathangnam1@gmail.com';

  return (
    <>
      <PageHeader
        title="Chính sách bảo mật"
        subtitle="Quy định về việc bảo mật thông tin cá nhân của khách hàng"
        breadcrumb={[
          { text: 'Trang chủ', link: '/' },
          { text: 'Chính sách bảo mật' }
        ]}
      />

      <section className="support-page">
        <div className="container">
          <div className="support-content">
            <p className="support-intro">
              {shopName} cam kết bảo vệ thông tin cá nhân của khách hàng. Chính sách bảo mật dưới đây sẽ giúp bạn hiểu rõ cách thức chúng tôi thu thập, sử dụng và bảo vệ thông tin của khách hàng khi truy cập website và thực hiện giao dịch.
            </p>

            <div className="support-section">
              <h2><span className="section-num">1</span> Thông tin chúng tôi thu thập</h2>
              <p>Chúng tôi thu thập thông tin cá nhân khách hàng khi:</p>
              <ul>
                <li>Đặt hàng trực tuyến qua website.</li>
                <li>Liên hệ qua email, điện thoại hoặc các kênh hỗ trợ khác.</li>
                <li>Đăng ký tài khoản hoặc tham gia các chương trình khuyến mãi.</li>
              </ul>
              <p>Các thông tin bao gồm:</p>
              <ul>
                <li>Họ và tên khách hàng</li>
                <li>Địa chỉ giao hàng cụ thể</li>
                <li>Số điện thoại người đặt</li>
                <li>Số điện thoại người nhận</li>
                <li>Thông tin thanh toán (màn hình giao dịch qua hình thức chuyển khoản, ví điện tử, Paypal,…)</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">2</span> Mục đích và phạm vi sử dụng thông tin</h2>
              <p>{shopName} sử dụng thông tin cá nhân của khách hàng cho các mục đích sau:</p>
              <ul>
                <li><strong>Xử lý đơn hàng:</strong> Để xác nhận và giao hoa đúng thời gian.</li>
                <li><strong>Cung cấp dịch vụ hỗ trợ:</strong> Để giải đáp các thắc mắc và xử lý yêu cầu của khách hàng.</li>
                <li><strong>Gửi thông báo khuyến mãi:</strong> {shopName} có thể gửi thông tin về các chương trình khuyến mãi, giảm giá hoặc sản phẩm mới qua email hoặc Zalo.</li>
                <li><strong>Cải thiện dịch vụ:</strong> Chúng tôi sử dụng thông tin để cải thiện chất lượng sản phẩm và dịch vụ của {shopName}</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">3</span> Chia sẻ thông tin cá nhân</h2>
              <ul>
                <li>{shopName} không bán hoặc chia sẻ thông tin cá nhân của khách hàng cho bất kì bên thứ ba nào, trừ khi có sự đồng ý của khách hàng hoặc yêu cầu từ cơ quan có thẩm quyền.</li>
                <li>Thông tin có thể được chia sẻ với các đối tác vận chuyển để thuận tiện cho việc liên lạc giao nhận hoa đúng địa chỉ theo yêu cầu.</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">4</span> Bảo mật thông tin</h2>
              <ul>
                <li>{shopName} cam kết bảo vệ thông tin cá nhân khách hàng bằng các biện pháp bảo mật nghiêm ngặt. Thông tin thanh toán được mã hóa bằng công nghệ SSL (Secure Sockets Layer) để đảm bảo tính bảo mật tuyệt đối.</li>
                <li>Chúng tôi sử dụng các phương thức bảo vệ kỹ thuật và tổ chức để ngăn ngừa truy cập trái phép, sử dụng sai mục đích hoặc tiết lộ thông tin.</li>
                <li>{shopName} sử dụng các biện pháp thích hợp về kỹ thuật và an ninh để ngăn chặn việc truy cập, sử dụng trái phép thông tin khách hàng. Các thông tin thanh toán của khách hàng được bảo vệ theo tiêu chuẩn Quốc tế với nguyên tắc không ghi nhận các dữ liệu quan trọng của thẻ (số thẻ, họ tên, CVV) trên hệ thống của {shopName}.</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">5</span> Cookie và công nghệ theo dõi</h2>
              <ul>
                <li>Cookie là các dữ liệu nhỏ được lưu trữ trên trình duyệt của bạn khi bạn truy cập website của chúng tôi. Cookie giúp chúng tôi cải thiện trải nghiệm người dùng, phân tích lưu lượng truy cập và cá nhân hóa các dịch vụ.</li>
                <li>Quý khách có thể tắt cookie trong cài đặt trình duyệt của mình, nhưng điều này có thể ảnh hưởng đến một số tính năng của website.</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">6</span> Quyền lợi của Khách hàng</h2>
              <p>Khách hàng đặt mua hoa tại {shopName} có quyền yêu cầu:</p>
              <ul>
                <li>Truy cập thông tin cá nhân mà chúng tôi lưu trữ về bạn.</li>
                <li>Sửa đổi hoặc cập nhật thông tin cá nhân nếu có sai sót.</li>
                <li>Xóa bỏ thông tin cá nhân theo yêu cầu, hoặc nếu không còn sử dụng dịch vụ của chúng tôi.</li>
              </ul>
            </div>

            <div className="support-section">
              <h2><span className="section-num">7</span> Liên hệ với chúng tôi</h2>
              <p>Nếu khách hàng có bất kì câu hỏi nào về chính sách bảo mật hoặc muốn yêu cầu quyền lợi của mình, vui lòng liên hệ với chúng tôi qua:</p>
              <ul>
                <li>Email: <a href={`mailto:${email}`}>{email}</a></li>
                <li>Số điện thoại: <a href={`tel:${phone}`}>{phone}</a></li>
              </ul>
              <div className="support-note" style={{ marginTop: '1rem' }}>
                <i className="fas fa-shield-alt"></i>
                <p>{shopName} cam kết hỗ trợ và bảo vệ quyền lợi cho khách hàng sử dụng dịch vụ, sản phẩm.</p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;
